import { useState } from 'react';
import firebase from 'firebase/compat/app';

const functions = firebase.functions();

/**
 * Modal for creating or editing a location
 */
export function LocationFormModal({ location, onClose, onSuccess }) {
  const [name, setName] = useState(location?.name || '');
  const [address, setAddress] = useState(location?.address || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!name || !address) {
      setError('Bitte füllen Sie alle Felder aus');
      setLoading(false);
      return;
    }

    try {
      if (location) {
        const updateLocation = functions.httpsCallable('updateLocation');
        await updateLocation({
          locationId: location.id,
          name,
          address
        });
      } else {
        const createLocation = functions.httpsCallable('createLocation');
        await createLocation({ name, address });
      }

      onSuccess();
    } catch (err) {
      // console statement removed for production
      setError(err.message || 'Fehler beim Speichern');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{location ? 'Standort bearbeiten' : 'Neuer Standort'}</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="z.B. Tödistrasse"
              required
            />
          </div>

          <div className="form-group">
            <label>Adresse *</label>
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="z.B. Tödistrasse 49, 8002 Zürich"
              required
            />
          </div>

          {error && (
            <div className="error-message">{error}</div>
          )}

          <div className="modal-actions">
            <button type="button" onClick={onClose} disabled={loading}>
              Abbrechen
            </button>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Speichert...' : (location ? 'Speichern' : 'Erstellen')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
